<template>
  <v-card
    class="pa-3"
    outlined
    style="border-radius: 6px; height: 100%"
    id="satisfaction"
  >
    <div class="pa-2 grey lighten-2" style="border-radius: 6px">
      <strong>{{ $t('Percentual de satisfação') }}</strong>
    </div>

    <div class="ml-2">
      <p class="my-2">{{ $t('Últimos 30 dias') }}</p>
      <strong>{{ $t('Quantidade') }}: {{ data.count }}</strong>
    </div>

    <div class="d-flex justify-center align-center" style="margin-top: 60px">
      <vue-gauge
        :key="data.result"
        :refid="'type-unique-id'"
        :options="myOptions"
      ></vue-gauge>
    </div>

    <div class="text-center" style="margin-top: -40px">
      <strong>{{ $t('Média de avaliações') }}: </strong>
      <strong style="font-size: 20px">
        {{ data.overall ? data.overall.toFixed(2) : '' }}
      </strong>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import VueGauge from 'vue-gauge'

export default {
  name: 'ScheduleComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
  },

  components: { VueGauge },

  data() {
    return {
      myOptions: {
        chartWidth: document.getElementById('satisfaction')
          ? document.getElementById('satisfaction').clientWidth
          : 250,
        needleColor: 'black',
        arcDelimiters: [37.5, 62.5, 87.5],
        arcColors: [
          'rgb(255,84,84)',
          'rgb(239,214,19)',
          'rgb(61,204,91)',
          '#0288d1',
        ],
        arcLabels: [this.$t('Regular'), this.$t('Bom')],
        rangeLabel: [this.$t('Ruim'), this.$t('Ótimo')],
        rangeLabelFontSize: 14,
      },
      options: {},
      apiService: new ApiService(),
      filter: {
        startDays: 0,
        page: 1,
        pageSize: 10,
        unidadeIds: [],
        departmentIds: [],
        institutionId: 1,
      },
      chartData: {},
      data: {
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    list() {
      this.apiService
        .post('dash/satisfaction', this.filter)
        .then((response) => {
          this.data = response.content
          this.myOptions.chartWidth =
            document.getElementById('satisfaction').clientWidth
          this.myOptions.needleValue = this.data.result
        })
    },
  },
}
</script>

<style scoped></style>
